import Cookies from 'js-cookie';
import toast from "react-hot-toast";
import { axiosInstance } from '../lib/axios';

const   loginapi = async (email, password) => {
    try {

        const res = await axiosInstance.post(
            `/users/login`,
            { email, password }
        );

        toast.success("Successfully Login");
        return res.data.data

    } catch (err) {
        console.log(err.response?.data?.message);
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
};


const checkAuthapi = async () => {
    try {
        const token = Cookies.get("accessToken");
        const res = await axiosInstance.get(
            `/users/profile`,
            {
                headers: { Authorization: `Bearer ${token}` },
            }
        );
        return res.data.data

    } catch (err) {
        console.log(err.response?.data?.message);
        // toast.error(err.response?.data?.message || "Something went wrong!");
    }
};

const getAllUserFunctionApi = async (pageNumber, pageSize, search, field) => {
    try {

        const params = new URLSearchParams();
        params.append('field', field);
        params.append('search', search);
        params.append('pageSize', pageSize);
        params.append('pageNumber', pageNumber);

        const accessToken = Cookies.get("accessToken");
        const res = await axiosInstance.get(`/users/getuser?${params.toString()}`, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        })
        // toast.success("Successfully fetched!");
        return res.data.data
        // console.log("lorem")

    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}


export {
    loginapi,
    checkAuthapi,
    getAllUserFunctionApi
}
